import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import {  useNavigate } from 'react-router-dom';
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { useAuthStore } from "../../store/auth.store.ts";
import Swal from "sweetalert2";

import { modificarContrasena  } from "../../api/misDatos.ts";

export default function MyAccountPage() {

    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();

    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    const [usuario, setUsuario] = useState({});
    const [rut, setRut] = useState("");


    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
      
    
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword:''
        });
    

    const [nombrePila, setNombrePila] = useState("");
    const [email, setEmail] = useState("");
    const [emailUsuario, setEmailUsuario] = useState("");
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);

    useEffect(() => {
            setUsuario(useAuthStore.getState().usuario);
            setRut(useAuthStore.getState().usuario.rut+'-'+useAuthStore.getState().usuario.dv);

            setNombrePila(useAuthStore.getState().usuario.nombre);
            setEmail(useAuthStore.getState().usuario.email);
            setEmailUsuario(useAuthStore.getState().usuario.email.split("@")[0]);
           
    }, [usuario]);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
    
      const handleValidation = (e)=>{
        const passwordInputValue = e.target.value.trim();
        const passwordInputFieldName = e.target.name;
    
        //for password
        if(passwordInputFieldName==='password'){
          const uppercaseRegExp   = /(?=.*?[A-Z])/;
          const lowercaseRegExp   = /(?=.*?[a-z])/;
          const specialCharRegExp = /(?=.*?[#?!@$%^&()*+._-])/;
          const minLengthRegExp   = /.{8,}/;
          const digitsRegExp      = /(?=.*?[0-9])/;
          const passwordLength =      passwordInputValue.length;
          const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
          const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
          const specialCharPassword = specialCharRegExp.test(passwordInputValue);
          const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
          const digitsPassword =      digitsRegExp.test(passwordInputValue);
    
          // check password include nombrePila in uppercase
          const nombrePilaInPassword = passwordInputValue.toUpperCase().includes(nombrePila.toUpperCase());
          const emailInPassword = passwordInputValue.toUpperCase().includes(email.toUpperCase());
          const emailUsuarioInPassword = passwordInputValue.toUpperCase().includes(emailUsuario.toUpperCase());
    
          let errMsg ="";
          if(passwordLength===0){
                  errMsg="Debe ingresar una contraseña";
          }else if(!uppercasePassword){
                  errMsg="Debe contener al menos una Mayúscula";
          }else if(!lowercasePassword){
                  errMsg="Debe contener al menos una Minúscula";
          }else if(!specialCharPassword){
                  errMsg="Debe contener al menos un caracter especial";
          }else if(!minLengthPassword){
                  errMsg="Debe contener al menos 8 caracteres";
          }else if(!digitsPassword){
                  errMsg="Debe contener al menos un número";
          }else if(nombrePilaInPassword){
                  errMsg="No debe contener su nombre";
          }else if(emailInPassword){
                  errMsg="No debe contener su email";
          }else if(emailUsuarioInPassword){
                  errMsg="No debe contener el nombre de usuario de su email";
          }else{
              errMsg="";
          }
          setPasswordErr(errMsg);
        }
        // for confirm password
        if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && formData.confirmPassword.length>0) ){
          if(formData.confirmPassword!==formData.password)
          {
          setConfirmPasswordError("Las contraseñas no coinciden");
          }else{
          setConfirmPasswordError("");
          }
        }
    }

    const handleSubmit = (e) => {
        
        e.preventDefault();
    
        e.preventDefault();
        try {
          setDisableSubmitButton(true)
    
          // Validar que no exista error de validación. passwordError y confirmPasswordError deben estar vacíos.
          // Además, realizar una doble validación de la cantidad minima de caracteres para evitar que se valide sin ingresar datos en los input.
    
          if(passwordError !== "" || confirmPasswordError !== ""){
            Swal.fire({icon: 'warning', text: "Las contraseñas no cumplen los requisitos mínimos." })
            setDisableSubmitButton(false)
            return;
          }
    
        
    
          modificarContrasena( formData.password, formData.confirmPassword)
          .then((res) => {
            if( res.error === false ) {
                Swal.fire({icon: 'success', text: 'Contraseña actualizada correctamente.'});
              localStorage.setItem("verificationCode", "");
              navigate("/");
            } else {
                Swal.fire({icon: 'warning', text: res.msg })
              setDisableSubmitButton(false)
            }
          })
    
    
        } catch (err) {
            Swal.fire({title: 'Error', text: 'Error al realizar cambio de contraseña. Si el problema persiste contacte al administrador.' })
          setDisableSubmitButton(false)
        }
    
       
      };

   
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Mi Cuenta</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                               
                                <li className="mc-breadcrumb-item">Mi Cuenta</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" title="Mi Perfil" className="mc-tabpane profile">
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('public_inFormation')}</h6>
                                    <Row>
                                        <Col xl={4}>
                                            <div className="mc-user-avatar-upload">
                                                <div className="mc-user-avatar">
                                                    <img src="images/LogoEmail.png" alt="avatar" />
                                                </div>
                                              
                                            </div>
                                        </Col>
                                        <Col xl={8}>
                                            <Row>
                                                <Col xl={6}><LegendFieldComponent type="text" title="Nombres" value={usuario.nombre} className="mb-4"/></Col>
                                                <Col xl={6}><LegendFieldComponent type="text" title="Apellidos" value={usuario.apellido} className="mb-4"/></Col>
                                                <Col xl={6}><LegendFieldComponent type="text" title="RUT" value={rut} className="mb-4"/></Col>
                                                <Col xl={6}><LegendFieldComponent type="text" title="Email" value={usuario.email} className="mb-4"/></Col>
                                                
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                               
                            </Tab>
                            <Tab eventKey="password" title="Cambiar Password" className="mc-tabpane password">
                            <form className="mc-auth-form" onSubmit={handleSubmit} >
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">Cambiar Password</h6>
                                    <h5 className="mc-duel-text-title">Su nueva contraseña debe cumplir las siguientes políticas de seguridad:</h5>
             
                                        <ul className="mc-user-metalist">
                                                                    <li><i className="material-icons">check</i><span>Mínimo de 8 carácteres.</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos una letra Mayúscula y una Minúscula.</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos un caracter especial (#?!@$%^&+*.-)</span></li>
                                                                    <li><i className="material-icons">check</i><span>Contener al menos un número.</span></li>
                                                                    <li><i className="material-icons">check</i><span>No incluir el nombre de la cuenta de usuario (email).</span></li>
                                                                    <li><i className="material-icons">check</i><span>No incluir su nombre de pila.</span></li>

                                                                </ul>
                                    <Row>
                                        <Col xs={12} md={12}><IconFieldComponent icon="lock" type="password" placeholder="Password Actual" classes="w-100 h-lg mb-4" passwordVisible /></Col>
                                        <Col xs={12} md={6}><IconFieldComponent icon="add_moderator" type="password" placeholder="Nueva Password" name="password" onChange={handleInputChange}    onKeyUp={handleValidation} classes="w-100 h-lg mb-4" passwordVisible />
                                        {passwordError !== "" ?
                                        <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{passwordError}</p>
                                        : null }
                                        
                                        </Col>
                                        <Col xs={12} md={6}><IconFieldComponent icon="verified_user" type="password" placeholder="Confirmar Password" name="confirmPassword"  onChange={handleInputChange}   onKeyUp={handleValidation}  classes="w-100 h-lg mb-4" passwordVisible />
                                        { confirmPasswordError !== "" ?
                                            <p className="mt-0 px-2 py-1 bg-red-50  text-red-600 border border-red-100 rounded text-sm">{confirmPasswordError}</p>
                                            : null }
                                        </Col>
                                    </Row>
                                </div>
                                <ButtonComponent className="mc-btn primary" icon="verified" text="Cambiar Password" />
                            </form>    
                            </Tab>
                            
                        </Tabs>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}